import React, { useRef } from 'react';

import './horizontal-scroll.scss';

const HorizontalScroll = ({
  children,
  onLastElementReached = () => {}
}) => {
    const scrollRef = useRef();

    const handleScroll = () => {
        if(!scrollRef?.current){
            return;
        }

        if(scrollRef.current.scrollLeft === scrollRef.current.scrollWidth - scrollRef.current.offsetWidth){
            onLastElementReached();
        }
    };

    return (
        <div className="horizontal-scroll" onScroll={handleScroll} ref={scrollRef}>
            <div className="horizontal-scroll-wrap">
                { children }
            </div>
        </div>
    );
};

export default HorizontalScroll;